module.exports = __webpack_public_path__ + "static/img/banner_1.2dfdc48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/banner_1.png
// module id = Y9LO
// module chunks = 1